<template>
  <div ref="pixel">
    <!-- Google Code for Purchase Conversion Page -->
    <noscript>
      <img
        height="1"
        width="1"
        border="0"
        :src="'//www.googleadservices.com/pagead/conversion/' + cid + '/?label=' + clabel + '&amp;guid=ON&amp;script=0'"
      />
    </noscript>
  </div>
</template>

<script>
export default {
  name: 'PixelTracker',
  props: {
    cid: {
      type: String,
      default: null
    },
    clabel: {
      type: String,
      default: null
    }
  },
  ready () {
    const pixelData = document.createElement('script')
    pixelData.innerHTML = `/* <![CDATA[ */
var google_conversion_id = {{cid}};
var google_conversion_label = "{{clabel}}";
var google_remarketing_only = "false";
/*  ]]> */`
    pixelData.setAttribute('type', 'text/javascript')
    this.$refs.pixel.appendChild(pixelData)

    const pixelScript = document.createElement('script')
    pixelScript.setAttribute('src', '//www.googleadservices.com/pagead/conversion.js')
    pixelScript.setAttribute('type', 'text/javascript')
    this.$refs.pixel.appendChild(pixelScript)
  },
  track (id, label) {
    var imgtag = document.createElement('img')
    imgtag.height = '1'
    imgtag.width = '1'
    imgtag.style = 'border-style:none;'
    imgtag.src = '//www.googleadservices.com/pagead/conversion/' + id + '/?label=' + label + '&amp;guid=ON&amp;script=0'
  }
}
</script>
